import { useState, useEffect } from "react"
import { BASE_URL } from '../../apiConfig';
import { useAuth } from "../../context/AuthProvider";
import { useNavigate, Link } from "react-router-dom";
import { toast } from 'sonner'; 

export default function UpdateRoleForm({ role }) {
  const { token } = useAuth();
  const router = useNavigate();
  const [formData, setFormData] = useState({
    id: 0,
    name: "",
    
    // PRODUCTS
    view_products: false,
    add_product: false,
    edit_product: false,
    delete_product: false,

    // CATEGORIES
    view_categories: false,
    add_category: false,
    edit_category: false,
    delete_category: false,

    // VARIANTS
    view_variants: false,
    add_variant: false,
    edit_variant: false,
    delete_variant: false,

    // FOURNISSEURS
    view_fournisseurs: false,
    add_fournisseur: false,
    edit_fournisseur: false,
    delete_fournisseur: false,

    // ORDERS
    view_orders: false,
    update_order: false,
    delete_order: false,
    scan_order: false,
    send_delivery: false,

    // CONFIRMATORS
    view_confirmator: false,
    add_confirmator: false,
    edit_confirmator: false,
    delete_confirmator: false,
    change_confirmator_password: false,

    // SELLERS
    view_saller: false,
    add_saller: false,
    edit_saller: false,
    delete_saller: false,
    change_saller_password: false,
    update_saller_status: false,

    // CONFIRMATOR INVOICES
    view_confirmator_invoices: false,
    generate_confirmator_invoices: false,
    pay_confirmator_invoices: false,
    delete_confirmator_invoices: false,

    // SELLER INVOICES
    view_saller_invoices: false,
    generate_saller_invoices: false,
    pay_saller_invoices: false,
    delete_saller_invoices: false,

    // STATISTICS
    view_statistics: false,
    
    // ANNONCES
    view_annonces: false,
    add_annonce: false,
    edit_annonce: false,
    delete_annonce: false,

    // RECLAMATIONS
    view_reclamations: false,
    reply_reclamation: false,
    delete_reclamation: false,

    // CONFIG
    edit_config: false,

    // BLACKLIST
    view_blacklist: false,
    add_blacklist: false,
    remove_blacklist: false,
  })

  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState({})
  const [success, setSuccess] = useState(false)

  useEffect(() => {
    if (role) {
      const roleData = role;
      setFormData({
        id: roleData.id,
        name: roleData.name,
        
        // PRODUCTS
        view_products: Boolean(roleData.view_products),
        add_product: Boolean(roleData.add_product),
        edit_product: Boolean(roleData.edit_product),
        delete_product: Boolean(roleData.delete_product),

        // CATEGORIES
        view_categories: Boolean(roleData.view_categories),
        add_category: Boolean(roleData.add_category),
        edit_category: Boolean(roleData.edit_category),
        delete_category: Boolean(roleData.delete_category),

        // VARIANTS
        view_variants: Boolean(roleData.view_variants),
        add_variant: Boolean(roleData.add_variant),
        edit_variant: Boolean(roleData.edit_variant),
        delete_variant: Boolean(roleData.delete_variant),

        // FOURNISSEURS
        view_fournisseurs: Boolean(roleData.view_fournisseurs),
        add_fournisseur: Boolean(roleData.add_fournisseur),
        edit_fournisseur: Boolean(roleData.edit_fournisseur),
        delete_fournisseur: Boolean(roleData.delete_fournisseur),

        // ORDERS
        view_orders: Boolean(roleData.view_orders),
        update_order: Boolean(roleData.update_order),
        delete_order: Boolean(roleData.delete_order),
        scan_order: Boolean(roleData.scan_order),
        send_delivery: Boolean(roleData.send_delivery),

        // CONFIRMATORS
        view_confirmator: Boolean(roleData.view_confirmator),
        add_confirmator: Boolean(roleData.add_confirmator),
        edit_confirmator: Boolean(roleData.edit_confirmator),
        delete_confirmator: Boolean(roleData.delete_confirmator),
        change_confirmator_password: Boolean(roleData.change_confirmator_password),

        // SELLERS
        view_saller: Boolean(roleData.view_saller),
        add_saller: Boolean(roleData.add_saller),
        edit_saller: Boolean(roleData.edit_saller),
        delete_saller: Boolean(roleData.delete_saller),
        change_saller_password: Boolean(roleData.change_saller_password),
        update_saller_status: Boolean(roleData.update_saller_status),

        // CONFIRMATOR INVOICES
        view_confirmator_invoices: Boolean(roleData.view_confirmator_invoices),
        generate_confirmator_invoices: Boolean(roleData.generate_confirmator_invoices),
        pay_confirmator_invoices: Boolean(roleData.pay_confirmator_invoices),
        delete_confirmator_invoices: Boolean(roleData.delete_confirmator_invoices),

        // SELLER INVOICES
        view_saller_invoices: Boolean(roleData.view_saller_invoices),
        generate_saller_invoices: Boolean(roleData.generate_saller_invoices),
        pay_saller_invoices: Boolean(roleData.pay_saller_invoices),
        delete_saller_invoices: Boolean(roleData.delete_saller_invoices),

        // STATISTICS
        view_statistics: Boolean(roleData.view_statistics),
        
        // ANNONCES
        view_annonces: Boolean(roleData.view_annonces),
        add_annonce: Boolean(roleData.add_annonce),
        edit_annonce: Boolean(roleData.edit_annonce),
        delete_annonce: Boolean(roleData.delete_annonce),

        // RECLAMATIONS
        view_reclamations: Boolean(roleData.view_reclamations),
        reply_reclamation: Boolean(roleData.reply_reclamation),
        delete_reclamation: Boolean(roleData.delete_reclamation),

        // CONFIG
        edit_config: Boolean(roleData.edit_config),

        // BLACKLIST
        view_blacklist: Boolean(roleData.view_blacklist),
        add_blacklist: Boolean(roleData.add_blacklist),
        remove_blacklist: Boolean(roleData.remove_blacklist),
      });
    }
  }, [role]);

  const formatPermissionName = (permissionKey) => {
    return permissionKey
      .replace(/_/g, ' ')
      .replace(/\b\w/g, c => c.toUpperCase())
      .replace(/saller/g, 'seller') 
      .replace(/fournisseur/g, 'supplier'); 
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    })
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" })
    }
  }

  // Handle bulk permission changes for groups
  const handleGroupPermissionChange = (permissions, value) => {
    const updatedData = { ...formData };
    permissions.forEach(permission => {
      updatedData[permission] = value;
    });
    setFormData(updatedData);
  };

  const validateForm = () => {
    const newErrors = {}

    if (!formData.name.trim()) newErrors.name = "Le nom du rôle est requis"

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsLoading(true);

    try {
      const res = await fetch(`${BASE_URL}/api/role/${formData.id}`, {
        method: "PUT",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!res.ok) throw new Error("Failed to update role");

      const data = await res.json();
      console.log("Role updated:", data);
      setSuccess(true);
      toast.success("Rôle modifié avec succès !");
      // router('/roles')
      setTimeout(() => {
        setSuccess(false);
      }, 1000);
    } catch (error) {
      console.error("Error updating role:", error);
      toast.error("Erreur lors de la modification du rôle");
    } finally {
      setIsLoading(false);
    }
  };

  // Group permissions for better UI organization
  const permissionGroups = {
    "Product Management": {
      permissions: [
        "view_products",
        "add_product",
        "edit_product", 
        "delete_product",
      ],
      description: "View and manage products"
    },
    "Category Management": {
      permissions: [
        "view_categories",
        "add_category",
        "edit_category",
        "delete_category",
      ],
      description: "Manage product categories"
    },
    "Variant Management": {
      permissions: [
        "view_variants",
        "add_variant",
        "edit_variant",
        "delete_variant",
      ],
      description: "Manage product variants"
    },
    "Supplier Management": {
      permissions: [
        "view_fournisseurs",
        "add_fournisseur",
        "edit_fournisseur",
        "delete_fournisseur",
      ],
      description: "Manage suppliers"
    },
    "Order Management": {
      permissions: [
        "view_orders",
        "update_order",
        "delete_order",
        "scan_order",
        "send_delivery",
      ],
      description: "Handle customer orders and deliveries"
    },
    "Confirmator Management": {
      permissions: [
        "view_confirmator",
        "add_confirmator",
        "edit_confirmator",
        "delete_confirmator",
        "change_confirmator_password",
      ],
      description: "Manage order confirmators"
    },
    "Seller Management": {
      permissions: [
        "view_saller",
        // "add_saller",
        "edit_saller",
        "delete_saller",
        "change_saller_password",
        "update_saller_status",
      ],
      description: "Manage seller accounts"
    },
    "Confirmator Invoices": {
      permissions: [
        "view_confirmator_invoices",
        "generate_confirmator_invoices",
        "pay_confirmator_invoices",
        "delete_confirmator_invoices",
      ],
      description: "Handle confirmator invoices and payments"
    },
    "Seller Invoices": {
      permissions: [
        "view_saller_invoices",
        "generate_saller_invoices",
        "pay_saller_invoices",
        "delete_saller_invoices",
      ],
      description: "Handle seller invoices and payments"
    },
    "Statistics": {
      permissions: [
        "view_statistics",
      ],
      description: "View system statistics and reports"
    },
    "Announcement Management": {
      permissions: [
        "view_annonces",
        "add_annonce",
        "edit_annonce",
        "delete_annonce",
      ],
      description: "Manage system announcements"
    },
    "Reclamation Management": {
      permissions: [
        "view_reclamations",
        "reply_reclamation",
        // "delete_reclamation",
      ],
      description: "Handle customer complaints and feedback"
    },
    "System Configuration": {
      permissions: [
        "edit_config",
      ],
      description: "Modify system settings"
    },
    "Blacklist Management": {
      permissions: [
        "view_blacklist",
        "add_blacklist",
        "remove_blacklist",
      ],
      description: "Manage blacklisted users or entities"
    },
  };

  // Get selected permissions for preview
  const getSelectedPermissionsSummary = () => {
    const selected = Object.keys(formData).filter(key =>
      key !== 'name' && key !== 'id' && formData[key] === true
    ).map(formatPermissionName);

    if (selected.length === 0) {
      return "Aucune permission sélectionnée";
    } else if (selected.length <= 3) {
      return selected.join(", ");
    } else {
      return `${selected.slice(0, 3).join(", ")}, et ${selected.length - 3} autres`;
    }
  };

  // Check if all permissions in a group are selected
  const isGroupFullySelected = (permissions) => {
    return permissions.every(permission => formData[permission]);
  };

  return (
    <div className="container mx-auto">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden">
        {success && (
          <div className="bg-[var(--color-primary-500)] text-white p-6 text-center animate-in slide-in-from-top duration-300">
            <div className="flex items-center justify-center mb-2">
              <svg className="h-8 w-8 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              <span className="text-lg font-semibold">Rôle modifié avec succès !</span>
            </div>
            <p className="text-[var(--color-primary-50)] text-xs">Le rôle a été mis à jour avec les permissions sélectionnées.</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="p-8">
          {/* Role Name */}
          <div className="mb-8">
            <label htmlFor="name" className="block text-sm font-semibold text-gray-900 mb-3">
              Nom du rôle *
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="ex: Administrateur, Éditeur, Gestionnaire Produits"
              className={`w-full py-3 px-4 text-xs border-2 outline-none rounded-2xl transition-all duration-200 bg-gray-50 focus:bg-white ${
                errors.name
                  ? "border-red-300 focus:border-red-500 focus:ring-4 focus:ring-red-100"
                  : "border-gray-200 focus:border-[var(--color-primary-500)] focus:ring-4 focus:ring-[var(--color-primary-100)]"
              }`}
            />
            {errors.name && <p className="mt-2 text-red-600 text-xs flex items-center">
              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {errors.name}
            </p>}
          </div>

          {/* Permissions Section */}
          <div className="mb-8">
            <h3 className="text-lg font-bold text-gray-900">Attribuer les permissions</h3>
            <p className="text-gray-600 text-xs mb-4">Sélectionnez les actions spécifiques que ce rôle pourra effectuer.</p>
            <div className="grid grid-cols-2 gap-2">
              {Object.entries(permissionGroups).map(([groupName, group]) => (
                <div key={groupName} className="border border-gray-200 rounded-xl px-3 py-4 bg-gray-50">
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <h4 className="text-xs font-semibold text-gray-800">{groupName}</h4>
                      <p className="text-[11px] text-gray-600 mt-1">{group.description}</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <button
                        type="button"
                        onClick={() => handleGroupPermissionChange(group.permissions, true)}
                        className="text-[11px] cursor-pointer  px-2 py-0.5 bg-green-100 text-green-700 rounded-md hover:bg-green-200 transition-colors"
                      >
                        Tout
                      </button>
                      <button
                        type="button"
                        onClick={() => handleGroupPermissionChange(group.permissions, false)}
                        className="text-[11px] cursor-pointer  px-2 py-0.5 bg-red-100 text-red-700 rounded-md hover:bg-red-200 transition-colors"
                      >
                        Aucun
                      </button>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
                    {group.permissions.map((permissionKey) => (
                      <div key={permissionKey} className="flex items-center">
                        <input
                          type="checkbox"
                          id={permissionKey}
                          name={permissionKey}
                          checked={formData[permissionKey]}
                          onChange={handleInputChange}
                          className="sr-only"
                        />
                        <label htmlFor={permissionKey} className="flex items-center gap-2 cursor-pointer">
                          <div className={`w-7 h-4 rounded-full transition-all duration-300 flex items-center ${
                            formData[permissionKey] ? 'bg-green-200' : 'bg-gray-200'
                          }`}>
                            <div className={`w-3 h-3 rounded-full shadow-md transition-transform duration-300 ${
                              formData[permissionKey] ? 'translate-x-3.5 bg-green-600' : 'translate-x-0.5 bg-gray-400'
                            }`} />
                          </div>
                          <span className="text-xs text-gray-700">
                            {formatPermissionName(permissionKey)}
                          </span>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Form Actions */}
          <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-gray-200">
            <Link 
              to="/roles" 
              className="flex-1 py-3 px-4 text-xs text-center border-2 border-gray-200 text-gray-700 font-semibold rounded-2xl hover:border-gray-300 hover:bg-gray-50 transition-all duration-200"
            >
              Annuler
            </Link>
            <button
              type="submit"
              disabled={isLoading}
              className={`flex-1 cursor-pointer py-3 px-4 text-xs font-semibold rounded-2xl transition-all duration-200 ${
                isLoading
                  ? "bg-gray-400 text-white cursor-not-allowed"
                  : "bg-[var(--color-primary-500)] hover:bg-[var(--color-primary-400)] text-white shadow-lg hover:shadow-xl transform hover:scale-105"
              }`}
            >
              {isLoading ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                  Mise à jour...
                </span>
              ) : (
                <span className="flex items-center justify-center">
                  Mettre à jour
                  <svg className="h-4 w-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                </span>
              )}
            </button>
          </div>

          {/* Preview */}
          {(formData.name || Object.values(formData).some(val => typeof val === 'boolean' && val)) && (
            <div className="mt-8 p-6 bg-gray-50 rounded-2xl border border-gray-200">
              <h3 className="font-semibold text-sm text-gray-900 mb-4">Aperçu du rôle</h3>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-[var(--color-primary-50)] rounded-2xl flex items-center justify-center">
                  <svg className="h-6 w-6 text-[var(--color-primary-500)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 14v6m-3-3h6M6 10h2m-2 4h2m-2 4h2M14 4h6V3m-6-1h6v12h-6V2zm-8 4v6h2V4H6zM4 14v6h2v-6H4zm0 0H2" />
                  </svg>
                </div>
                <div className="flex-1">
                  <div className="font-semibold text-sm text-gray-900 mb-1">
                    {formData.name || "Nom du rôle"}
                  </div>
                  <div className="text-xs text-gray-600 mb-2">
                    Permissions: {getSelectedPermissionsSummary()}
                  </div>
                  <div className="text-[11px] text-gray-500">
                    {Object.values(formData).filter(val => typeof val === 'boolean' && val).length} permissions au total
                  </div>
                </div>
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  )
}